import { Controller } from "stimulus";
import "select2/dist/css/select2.css";
import "@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css";
import "select2";

export default class extends Controller {

    connect() {
        const $select = $(this.element);

        const topCities = [
            { id: 4389, text: "гр. София (общ. Столична, обл. София-град)" },
            { id: 648,  text: "гр. Варна (общ. Варна, обл. Добрич)" },
            { id: 563,  text: "гр. Бургас (общ. Бургас, обл. Бургас)" },
            { id: 4063, text: "гр. Русе (общ. Русе, обл. Русе)" },
            { id: 3598, text: "гр. Пловдив (общ. Пловдив, обл. Пловдив)" }
        ];

        $select.select2({
            theme: "bootstrap4",
            minimumInputLength: 0,
            ajax: {
                url: this.element.getAttribute("data-ajax-url"),
                dataType: "json",
                delay: 150,

                data: params => ({
                    q: params.term || "",
                    page: params.page || 1
                }),

                processResults: data => ({
                    results: data.results,
                    pagination: {
                        more: data.more ?? false
                    }
                }),

                transport: (params, success) => {

                    const search = params.data.q;

                    if (!search || search.length === 0) {
                        success({
                            results: topCities,
                            more: false
                        });
                        return;
                    }

                    $.ajax(params).then(success);
                }
            }
        });


        $select.on("select2:open", () => {
            setTimeout(() => {
                const input = document.querySelector(".select2-search__field");
                if (input) {
                    input.placeholder = this.element.dataset.searchPlaceholder || "";
                    input.focus();
                }
            }, 0);
        });


        $select.on("select2:select", (e) => {
            const eventName = this.element.dataset.eventOnSelect;
            if (eventName) {
                EventManager.fire(eventName, e.params.data.id);
            }
        });

    }
}
